import React from 'react'

import VdpAlpha from '../../components/template/VdpAlpha.template'

const VdpView = () => {
    return <VdpAlpha />
}

export default VdpView
